import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactScrollbar from 'react-scrollbar-js';
import BasketComponent from './BasketComponent';
import KeyboardComponent from './KeyboardComponent';
import Navbar from '../../../components/Navbar';
import {BasketPropTypes, TeamPropTypes} from "../../../utils/propTypes";


class ResultEntryComponent extends Component {
    onKeyboardClick(score) {
        const basketId = this.props.activeBasket.id;
        const activeTeamId = this.props.activeTeam.id;
        const previousResult = this.props.activeBasket.results.find(r => r.team === activeTeamId).result;
        const result = {...this.props.activeBasket.results.find(r => r.team === activeTeamId), result: score};

        if (previousResult !== score) {
            this.props.setScore(basketId, result);
        }
    }

    changeOb(obChange) {
        const basketId = this.props.activeBasket.id;
        const activeTeamId = this.props.activeTeam.id;
        const result = {...this.props.activeBasket.results.find(r => r.team === activeTeamId)};
        result.ob += obChange;

        if (result.ob >= 0) {
            this.props.setOb(basketId, result);
        }
    }

    navigate(direction) {
        // Change Basket
        const basketId = this.props.activeBasket.id;
        this.props.navigate(basketId, direction);

        // Bubble proporties
        const bubbleWidth = 50;
        const nextBubbleNumber = (this.props.activeBasket.number + direction) - 1;
        const nextBubble = nextBubbleNumber >= 1 ? nextBubbleNumber : 1;

        // Basket Scrolling-Center Animation
        const visibleWidth = this.scrollingContainer.clientWidth;
        const totalWidth = this.scrollableContent.clientWidth;
        const halfVisibleWidth = visibleWidth / 2;
        const offsetMiddleBubble = halfVisibleWidth % bubbleWidth;

        const middleBubbleValue = ((nextBubble - 1) * bubbleWidth) + offsetMiddleBubble;
        const afterBubbleDistance = totalWidth - middleBubbleValue;

        if (halfVisibleWidth < middleBubbleValue || halfVisibleWidth < afterBubbleDistance) {
            this.scroll.scrollToX(middleBubbleValue);
        }
    }

    calculateBasketBubbleClass(basket) {
        let returnClass = basket.id === this.props.activeBasket.id ? 'bubble--current ' : '';
        const missingResults = basket.results.filter(result => result.result === null);
        returnClass += !missingResults.length > 0 ? 'bubble--ok ' : '';
        return returnClass;
    }

    renderTitlebar() {
        return (
            <div className="titlebar" ref={(c) => { this.scrollingContainer = c; }}>
                <div className="container">
                    <span className="bubbles">
                        <span
                            className="arrow-previous"
                            onClick={() => this.navigate(-1)}
                        ><span className="icon" /></span>
                        <ReactScrollbar className="react-scrollbar--bubbles" ref={(c) => { this.scroll = c; }}>
                            <div className="react-scrollbar-container" ref={(c) => { this.scrollableContent = c; }}>
                                {this.props.baskets.map((basket) => {
                                    const bubbleClass = `bubble ${this.calculateBasketBubbleClass(basket)}`;
                                    return (
                                        <span
                                            key={basket.id}
                                            onClick={() => this.props.navigate(basket.id)}
                                            onTouchStart={() => this.props.navigate(basket.id)}
                                            className={bubbleClass}
                                        >{basket.visible_number}</span>
                                    );
                                })}
                            </div>
                        </ReactScrollbar>
                        <span
                            className="arrow-next"
                            onClick={() => this.navigate(1)}
                        ><span className="icon" /></span>
                    </span>
                </div>
            </div>
        );
    }

    renderNavbar() {
        // The default navbar text is something like 'TEE 3 / 24'
        let navbarLeftText = `TEE ${this.props.activeBasket.visible_number} / ${this.props.teeCount}`;

        // But if the course has "split up courses (1A/1B) then the format will be 'TEE 3A (4 / 24)'
        if (this.props.uniqueTeeCount !== this.props.teeCount) {
            navbarLeftText = `TEE ${this.props.activeBasket.visible_number} (${this.props.activeBasket.number} 
            / ${this.props.teeCount})`;
        }
        const navbarRightText = `PAR ${this.props.activeBasket.par}`;
        return <Navbar textLeft={navbarLeftText} textRight={navbarRightText} />;
    }

    render() {
        if (!this.props.activeBasket) {
            return null;
        }

        const navbar = this.renderNavbar();
        const titleBar = this.renderTitlebar();
        return (
            <div>
                {navbar}
                {titleBar}
                <BasketComponent
                    activeTeam={this.props.activeTeam}
                    activeBasket={this.props.activeBasket}
                    teams={this.props.teams}
                    activateTeam={this.props.activateTeam}
                    resultsByTeam={this.props.resultsByTeam}
                />
                <KeyboardComponent
                    baskets={this.props.baskets}
                    activeBasket={this.props.activeBasket}
                    onKeyboardClick={score => this.onKeyboardClick(score)}
                    changeOb={ob => this.changeOb(ob)}
                    navigate={direction => this.navigate(direction)}
                    finishGame={() => this.props.finishGame(this.props.gameId)}
                />
            </div>
        );
    }
}

ResultEntryComponent.propTypes = {
    finishGame: PropTypes.func.isRequired,
    gameId: PropTypes.number,
    uniqueTeeCount: PropTypes.number.isRequired,
    teeCount: PropTypes.number.isRequired,
    setScore: PropTypes.func.isRequired,
    setOb: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    activeBasket: PropTypes.shape(),
    activateTeam: PropTypes.func.isRequired,
    baskets: PropTypes.arrayOf(BasketPropTypes),
    teams: PropTypes.arrayOf(TeamPropTypes),
    resultsByTeam: PropTypes.shape(),
    activeTeam: TeamPropTypes,
};


export default ResultEntryComponent;



// WEBPACK FOOTER //
// ./src/apps/result_entry/components/ResultEntryComponent.js